import React from 'react'
import { Container, FormInfoWrapper } from './style'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

const MedicationsInfo = () => {
  const { selectedClient } = useSelector((state: RootState) => state.professionals);

  return (
    <Container>
      <FormInfoWrapper>
        {selectedClient?.otherMedication?.content ?
          <em>{selectedClient?.otherMedication?.content}</em>
          :
          <span>None</span>
        }
      </FormInfoWrapper>
    </Container>
  )
}

export default MedicationsInfo
